import React from 'react';

export default function BackLink({ onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        color: '#777',
        fontSize: '0.95em',
        marginBottom: '0.5em',
        cursor: 'pointer'
      }}
    >
      ← regresar
    </div>
  );
}
